import moment from "moment";
import Vue from 'vue';
import { router } from '@/router';
import _ from 'lodash';
import store from '@/store';
import ReportsService from '@/services/ReportsService';

function initialState() {
    return {
        AddOnsReportExcelFileName: null,
        AddOnsReportPDFFileName: null,
        dropDownObject: {
            fromDate: new Date(),
            cinema_name: null,
            cinema_id: null,
        },
        AddOnsReport: [],
        AllAddOnsReport: [],
        pdfrecord: '',
        excelrecord: ''
    }
}

const state = initialState();

const mutations = {
    SET_ADD_ONS_DROP_DOWN_VALUES: (state, payload) => {
        switch (payload.name) {
            case 'isCinema':
                state.dropDownObject.cinema_id = payload['selectedItem'] ? payload.selectedItem.cine_id : null;
                state.dropDownObject.cinema_name = payload['selectedItem'] ? payload.selectedItem.cine_name : null;
                break;
            case 'fromDate':
                state.dropDownObject.fromDate = payload['event'] ? payload['event'] : null;
                break;
            default: console.log('Advance Sales Report :( Sorry, we are enable to set value.');
        }
    },
    ON_RESET_ADD_ONS_REPORT_STORE_STATE: (state, payload) => {
        // state = initialState();
        const s = initialState()
        Object.keys(s).forEach(key => {
            state[key] = s[key]
        })
    },
    SET_ADD_ONS_REPORT_DATES: (state, payload) => {
        // console.log('payload :', payload);
        payload['name'] ? state.dropDownObject[payload.name] = payload['event'] ? payload.event : null : '';
    },

    SET_ADD_ONS_REPORT_DATA: (state, payload) => {
        state.AddOnsReport = payload.Records || [];
        state.AllAddOnsReport = payload.AllRecords || [];
    },
    SET_ADD_ONS_EXCEL_FILE_NAME: (state, payload) => {
        state.AddOnsReportExcelFileName = payload;
    },
    SET_ADD_ONS_PDF_FILE_NAME: (state, payload) => {
        state.AddOnsReportPDFFileName = payload;
    },
}

const actions = {
    onAddOnsReportDropDownHandler: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_ADD_ONS_DROP_DOWN_VALUES', payload);
    },
    onAddOnsReportDateHandler: async ({ dispatch, commit, state }, payload) => {
        commit('SET_ADD_ONS_REPORT_DATES', payload)
    },
    onResetAddOnsStoreState: async ({ dispatch, commit, state }, { ...payload }) => {
        await commit('ON_RESET_ADD_ONS_REPORT_STORE_STATE');
    },
    onFetchAddOnsReport: async ({ dispatch, commit, state }, payload) => {
        // console.log('object');
        let request_payload = {}

        if (state.dropDownObject.cinema_id && state.dropDownObject.cinema_id != null) {
            request_payload = state.dropDownObject

            await commit('SET_ADD_ONS_REPORT_DATA', [])
            let loader = Vue.$loading.show();

            await ReportsService.GetAddOnsReport(request_payload)
                .then(async (response) => {
                    loader.hide();
                    const { data } = response;
                    if (data.status && data.Records.length > 0) {
                        commit('SET_ADD_ONS_REPORT_DATA', data)

                        await commit('SET_ADD_ONS_EXCEL_FILE_NAME', data['ExcelName'] || null);
                        await commit('SET_ADD_ONS_PDF_FILE_NAME', data['PDFName'] || null);
                    } else {
                        Vue.toasted.show(data.message);
                    }
                }).catch((error) => {
                    loader.hide();
                    Vue.toasted.show("Catch Error on Add Ons Report", error);
                });
        } else {
            Vue.toasted.show("Please select Cinema.");
        }
    },
}

const getters = {
    getAddOnsReportsSelectedCinema: state => state.dropDownObject.cinema_name,
    getAddOnsReportFromDate: state => state.dropDownObject.fromDate,
    getAddOnsReportData: state => state.AddOnsReport,
    getAllAddOnsData: state => state.AllAddOnsReport,
    // Get File name
    getAddOnsExcelFileName: state => state.AddOnsReportExcelFileName,
    getAddOnsPdfFileName: state => state.AddOnsReportPDFFileName,
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/AddOnsReportStore.js